import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  FilterAccordionHeader,
  Row,
  Col,
  Select,
  Checkbox,
  TextField
} from '@folio/stripes/components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field } from 'react-final-form';

function AdvancedSettings() {
  const [filterToggle, setFilterToggle] = useState(false);
  const intl = useIntl();

  const cachingStrategyOptions = [
    { value: 'aggressive', label: intl.formatMessage({ id: 'ui-reports.caching.strategy.aggressive', defaultMessage: 'Aggressive' }) },
    { value: 'normal',     label: intl.formatMessage({ id: 'ui-reports.caching.strategy.normal',     defaultMessage: 'Normal' }) },
    { value: 'minimal',   label: intl.formatMessage({ id: 'ui-reports.caching.strategy.minimal',   defaultMessage: 'Minimal' }) },
    { value: 'none',      label: intl.formatMessage({ id: 'ui-reports.caching.strategy.none',      defaultMessage: 'None' }) },
  ];

  const complexityOptions = [
    { value: 'low',       label: intl.formatMessage({ id: 'ui-reports.performance.complexity.low',       defaultMessage: 'Low' }) },
    { value: 'medium',    label: intl.formatMessage({ id: 'ui-reports.performance.complexity.medium',    defaultMessage: 'Medium' }) },
    { value: 'high',      label: intl.formatMessage({ id: 'ui-reports.performance.complexity.high',      defaultMessage: 'High' }) },
    { value: 'very_high', label: intl.formatMessage({ id: 'ui-reports.performance.complexity.very_high', defaultMessage: 'Very High' }) },
  ];

  const dataVolumeOptions = [
    { value: 'small',      label: intl.formatMessage({ id: 'ui-reports.performance.dataVolume.small',      defaultMessage: 'Small' }) },
    { value: 'medium',     label: intl.formatMessage({ id: 'ui-reports.performance.dataVolume.medium',     defaultMessage: 'Medium' }) },
    { value: 'large',      label: intl.formatMessage({ id: 'ui-reports.performance.dataVolume.large',      defaultMessage: 'Large' }) },
    { value: 'very_large', label: intl.formatMessage({ id: 'ui-reports.performance.dataVolume.very_large', defaultMessage: 'Very Large' }) },
  ];

  return (
    <Accordion
      id="save-new-report-advanced-settings-accordion"
      label={
        <FormattedMessage
          id="ui-reports.saveNewReportForm.advancedSettings.accordion.header"
          defaultMessage="Advanced Settings"
        />
      }
      onToggle={() => setFilterToggle(!filterToggle)}
      open={filterToggle}
      separator
      header={FilterAccordionHeader}
    >
      <Row>
        <Col xs={12}>
          <h4>
            <FormattedMessage
              id="ui-reports.advancedSettings.caching"
              defaultMessage="Caching"
            />
          </h4>
        </Col>
      </Row>

      <Row>
        <Col xs={4}>
          <Field
            name="caching.enabled"
            component={Checkbox}
            type="checkbox"
            label={
              <FormattedMessage
                id="ui-reports.caching.enabled"
                defaultMessage="Enable Caching"
              />
            }
          />
        </Col>
        <Col xs={4}>
          <Field
            name="caching.ttl"
            component={TextField}
            type="number"
            label={
              <FormattedMessage
                id="ui-reports.caching.ttl"
                defaultMessage="TTL (seconds)"
              />
            }
          />
        </Col>
        <Col xs={4}>
          <Field
            name="caching.strategy"
            component={Select}
            label={
              <FormattedMessage
                id="ui-reports.caching.strategy"
                defaultMessage="Strategy"
              />
            }
            dataOptions={cachingStrategyOptions}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <h4>
            <FormattedMessage
              id="ui-reports.advancedSettings.performance"
              defaultMessage="Performance"
            />
          </h4>
        </Col>
      </Row>

      <Row>
        <Col xs={4}>
          <Field
            name="performance.complexity"
            component={Select}
            label={
              <FormattedMessage
                id="ui-reports.performance.complexity"
                defaultMessage="Complexity"
              />
            }
            dataOptions={complexityOptions}
          />
        </Col>
        <Col xs={4}>
          <Field
            name="performance.dataVolume"
            component={Select}
            label={
              <FormattedMessage
                id="ui-reports.performance.dataVolume"
                defaultMessage="Data Volume"
              />
            }
            dataOptions={dataVolumeOptions}
          />
        </Col>
        <Col xs={4}>
          <Field
            name="performance.maxExecutionTime"
            component={TextField}
            type="number"
            label={
              <FormattedMessage
                id="ui-reports.performance.maxExecutionTime"
                defaultMessage="Max Execution Time (ms)"
              />
            }
          />
        </Col>
      </Row>
    </Accordion>
  );
}

AdvancedSettings.propTypes = {};

export default AdvancedSettings;
